module.exports = __webpack_public_path__ + "img/Dahlia1.6f69cd9e.jpg";